


































import { IProduct } from '@/common/interfaces/products.interface';
import Vue from 'vue';
import config from '../../../config';
import OldFormatHelper from '../../helpers/OldFormatHelper';
import ProductListPriceDisplay from './ProductListPriceDisplay.vue';

export default Vue.extend({
  name: `ProductListDetails`,
  components: { ProductListPriceDisplay },
  props: {
    discountActive: {
      required: true,
      type: Boolean,
    },
    hasMultipleCarts: {
      required: true,
      type: Boolean,
    },
    isPartner: {
      required: true,
      type: Boolean,
    },
    mode: {
      required: true,
      type: String,
    },
    product: {
      required: true,
      type: Object as () => IProduct,
    },
  },
  methods: {
    getBasePriceText(product: IProduct): string {
      let response = ``;
      if(config.products.unitContentsIds.includes(product.unitContentsId)) {
        response = `${OldFormatHelper.getPrice(product.basePrice.brutto)} / ${product.basePrice.amount} ${product.basePrice.unit}`;
      }
      return response;
    },
    hasBasePrice(product: IProduct): boolean {
      for(const value of Object.values(product.basePrice)) {
        if(value === null) {
          return false;
        }
      }
      return true;
    },
  },
});
